<div class="financial-account-selection-title">{{ type | titlecase }} Account</div>

@if (formAction$ | async; as formAction) {
  <div class="financial-account-container">
    @if (type === 'from') {
      @if ((fromAccount$ | async) === null) {
        <button class="empty-state-button" (click)="onSelectFinancialAccountClick()" appRemoveFocus>
          <div class="empty-state-icon"><rkt-icon name="plus"></rkt-icon></div>
        </button>
      }
      @if (fromAccount$ | async; as fromAccount) {
        <div class="selected-financial-account">
          <div class="rows">
            <div class="row">
              <div class="label">Account Holder:</div>
              <div class="value">
                <div [class.empty-value]="!(fromAccount.accountHolderInfo || '' | rktSplit: '::' : 0)">
                  {{ fromAccount.accountHolderInfo || '' | rktSplit: '::' : 0 | notAvailable: '--' }}
                </div>
                <div [class.empty-value]="!(fromAccount.accountHolderInfo || '' | rktSplit: '::' : 1)">
                  {{ fromAccount.accountHolderInfo || '' | rktSplit: '::' : 1 | notAvailable: '--' }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="label">Account Info:</div>
              <div class="value">
                <div [class.empty-value]="!(fromAccount.accountInfo | rktSplit: '::' : 0)">
                  {{ fromAccount.accountInfo | rktSplit: '::' : 0 | notAvailable: '--' }}
                </div>
                <div [class.empty-value]="!(fromAccount.accountInfo | rktSplit: '::' : 1)">
                  {{ fromAccount.accountInfo | rktSplit: '::' : 1 | notAvailable: '--' }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="label">Account Category:</div>
              <div class="value">{{ fromAccount.accountCategory }}</div>
            </div>
            @if (fromAccount.category !== 'EXTERNAL') {
              <div class="row">
                <div class="label">Available Balance:</div>
                <div class="value">
                  @if (fromAccount.availableBalance !== undefined) {
                    <div>
                      {{ fromAccount.currency | currencySign }}
                      {{ (fromAccount.availableBalance | number: '1.2-2') || '' | mask: 'separator' : { thousandSeparator: ',' } }}
                    </div>
                  } @else {
                    <div class="empty-value">--</div>
                  }
                </div>
              </div>
            }
          </div>
          @if ((isDebitLegsDisabled$ | async) === false) {
            <div class="edit-btn-wrapper">
              <button
                class="edit-btn"
                (click)="onSelectFinancialAccountClick({ selectedFinancialAccount: fromAccount, formAction, fromAccount })"
              >
                <rkt-icon name="edit"></rkt-icon>
              </button>
            </div>
          }
        </div>
      }
    }
    @if (type === 'to') {
      @if ((toAccount$ | async) === null && (fromAccount$ | async); as fromAccount) {
        <button class="empty-state-button" (click)="onSelectFinancialAccountClick({ fromAccount, formAction })" appRemoveFocus>
          <div class="empty-state-icon"><rkt-icon name="plus"></rkt-icon></div>
        </button>
      }
      @if ((toAccount$ | async) === null && (fromAccount$ | async) === null) {
        <button class="empty-state-button" (click)="onSelectFinancialAccountClick()" [attr.disabled]="true" appRemoveFocus>
          <div class="empty-state-icon"><rkt-icon name="plus"></rkt-icon></div>
        </button>
      }
      @if (toAccount$ | async; as toAccount) {
        <div class="selected-financial-account">
          <div class="rows">
            <div class="row">
              <div class="label">Account Holder:</div>
              <div class="value">
                <div [class.empty-value]="!(toAccount.accountHolderInfo || '' | rktSplit: '::' : 0)">
                  {{ toAccount.accountHolderInfo || '' | rktSplit: '::' : 0 | notAvailable: '--' }}
                </div>
                <div [class.empty-value]="!(toAccount.accountHolderInfo || '' | rktSplit: '::' : 1)">
                  {{ toAccount.accountHolderInfo || '' | rktSplit: '::' : 1 | notAvailable: '--' }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="label">Account Info:</div>
              <div class="value">
                <div [class.empty-value]="!(toAccount.accountInfo | rktSplit: '::' : 0)">
                  {{ toAccount.accountInfo | rktSplit: '::' : 0 | notAvailable: '--' }}
                </div>
                <div [class.empty-value]="!(toAccount.accountInfo | rktSplit: '::' : 1)">
                  {{ toAccount.accountInfo | rktSplit: '::' : 1 | notAvailable: '--' }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="label">Account Category:</div>
              <div class="value">{{ toAccount.accountCategory }}</div>
            </div>
            @if (toAccount.category !== 'EXTERNAL') {
              <div class="row">
                <div class="label">Available Balance:</div>
                <div class="value">
                  @if (toAccount.availableBalance !== undefined) {
                    <div>
                      {{ toAccount.currency | currencySign }}
                      {{ (toAccount.availableBalance | number: '1.2-2') || '' | mask: 'separator' : { thousandSeparator: ',' } }}
                    </div>
                  } @else {
                    <div class="empty-value">--</div>
                  }
                </div>
              </div>
            }
          </div>
          @if (fromAccount$ | async; as fromAccount) {
            <div class="edit-btn-wrapper">
              <button
                class="edit-btn"
                (click)="onSelectFinancialAccountClick({ selectedFinancialAccount: toAccount, formAction, fromAccount })"
              >
                <rkt-icon name="edit"></rkt-icon>
              </button>
            </div>
          }
        </div>
      }
    }
  </div>
}
